import { Chain } from '@ankr.com/chains-list';
import { useMemo } from 'react';

import { chainTypeMap } from 'modules/chains/constants';
import { getChainLabels } from 'modules/chains/utils/getChainLabels';
import { getChainTypeTabs } from 'modules/chains/utils/getChainTypeTabs';
import { useGroupedEndpoints } from 'modules/endpoints/hooks/useGrouppedEndpoints';

interface UseSubchainLabelsProps {
  chain: Chain;
}

export const useSubchainLabels = ({ chain }: UseSubchainLabelsProps) => {
  const groupedEndpoints = useGroupedEndpoints(chain);

  const subchainLabels = useMemo(
    () =>
      getChainLabels(
        chain,
        getChainTypeTabs().filter(
          ({ id }) => groupedEndpoints[chainTypeMap[id]]?.length > 0,
        ),
      ),
    [chain, groupedEndpoints],
  );

  return subchainLabels;
};
